import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SectionHeading, EmptySection, Field, BoolBadge, formatTime } from './shared';
import PhotoGrid from './PhotoGrid';
import type { PhotoAttachmentWithUrl } from '@/services/db/dsrDetail';

interface Props {
  data: any[];
  photos?: PhotoAttachmentWithUrl[];
}

const TYPE_COLORS: Record<string, string> = {
  positive: 'bg-mozaic-green/15 text-mozaic-green',
  at_risk: 'bg-mozaic-orange/15 text-mozaic-orange',
  pta: 'bg-mozaic-red/15 text-mozaic-red',
};

export default function HSEObservationsSection({ data, photos = [] }: Props) {
  return (
    <section>
      <SectionHeading id="section-hse-observations" title="HSE Observations" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="HSE observations" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <Badge className={TYPE_COLORS[row.observation_type] ?? 'bg-muted text-muted-foreground'}>
                    {(row.observation_type ?? '').replace(/_/g, ' ').toUpperCase()}
                  </Badge>
                  {row.observation_category && (
                    <Badge variant="outline" className="text-xs">
                      {row.observation_category.replace(/_/g, ' ')}
                    </Badge>
                  )}
                  <BoolBadge value={row.is_resolved} />
                </div>
                <p className="mb-3 text-sm">{row.description}</p>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                  <Field label="Time" value={formatTime(row.observation_time)} />
                  <Field label="Location" value={row.location_detail} />
                  <Field label="Associated Crew" value={row.associated_crew} />
                  <Field label="Observed By" value={row.observed_by} />
                  {row.corrective_action && (
                    <div className="col-span-full">
                      <Field label="Corrective Action" value={row.corrective_action} />
                    </div>
                  )}
                  {row.comments && (
                    <div className="col-span-full">
                      <Field label="Comments" value={row.comments} />
                    </div>
                  )}
                </div>
                <PhotoGrid photos={photos} entityId={row.id} />
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
